import { render, staticRenderFns } from "./reimbursement_info.vue?vue&type=template&id=6c60cfa7&scoped=true"
import script from "./reimbursement_info.vue?vue&type=script&lang=js"
export * from "./reimbursement_info.vue?vue&type=script&lang=js"
import style0 from "./reimbursement_info.vue?vue&type=style&index=0&id=6c60cfa7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c60cfa7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
